import { render, staticRenderFns } from "./InstagramIconOverlay.vue?vue&type=template&id=58d547a8&scoped=true"
import script from "./InstagramIconOverlay.vue?vue&type=script&lang=ts"
export * from "./InstagramIconOverlay.vue?vue&type=script&lang=ts"
import style0 from "./InstagramIconOverlay.vue?vue&type=style&index=0&id=58d547a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d547a8",
  null
  
)

export default component.exports